import { Col, Collapse, Row, Table } from "antd";
import React from "react";
import TagComponent from "../../../../biblio/TagComponent";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
interface Props {
  sponsorship: any;
}
export const CancelSponsorShipList = ({ sponsorship }: Props) => {
  const { t } = useTranslation();
  const columns = [
    {
      title: "المستفيد",
      dataIndex: "partner_id",
      key: "partner_id",
      render: (partner_id: string) => (
        <span className="takaful--service-request-span">{partner_id}</span>
      ),
    },
   
    {
      title: "نوع الكفالة الملغاة",
      dataIndex: "cancel_sponsorship_status",
      key: "cancel_sponsorship_status",
      render: (cancel_sponsorship_status: any) => (
        <span className="takaful--service-request-span">
          {cancel_sponsorship_status !== false &&
            t(`cancel_sponsorship_status.${cancel_sponsorship_status}`)}
        </span>
      ),
    },
    {
      title: "تاريخ الإلغاء الكفالة",
      dataIndex: "sponsorship_cancel_date",
      key: "sponsorship_cancel_date",
      render: (sponsorship_cancel_date: any) => (
        <span className="takaful--service-request-span">
          {sponsorship_cancel_date !== false && sponsorship_cancel_date
            ? dayjs(sponsorship_cancel_date, "YYYY-MM-DD").format("YYYY/MM/DD")
            : ""}
        </span>
      ),
    },
    
  ];
  return (
    <div
      className="takaful--collapse-profile-container"
      style={{ marginTop: "2rem" }}
    >
      <div
        className={`takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services  `}
      >
        <Collapse.Panel
          showArrow={false}
          key="0"
          className=" takaful--collapse-label-panel"
          header={
            <div className="takaful--header-profile-container">
              <Row
                className="takaful--content-profile-box1"
                style={{ marginBottom: "0" }}
              >
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    رقم الإلغاء
                  </p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    تاريخ الإلغاء
                  </p>
                </Col>
                <Col
                  xxl={7}
                  xl={7}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    سبب الإلغاء
                  </p>
                </Col>
                <Col
                  xxl={5}
                  xl={5}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">المرحلة</p>
                </Col>
              </Row>
            </div>
          }
        ></Collapse.Panel>
      </div>
      <Collapse
        className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
        accordion
        defaultActiveKey={["0"]}
      >
        {sponsorship?.map((element: any, index: number) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel"
            key={index}
            showArrow={false}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  justify={"space-between"}
                  className="takaful--content-profile-box1 takaful--cancelSponsorShip-list"
                  style={{ marginBottom: "0" }}
                >
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      رقم الإلغاء
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.name}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      تاريخ الإلغاء
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.date
                        ? dayjs(element?.date, "YYYY-MM-DD").format(
                            "YYYY/MM/DD"
                          )
                        : ""}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      سبب الإلغاء
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.cancel_reason_id}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      المرحلة
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={7}
                    md={7}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <TagComponent
                      className="takaful--tag-component"
                      width="50%"
                      state={element?.state}
                      orangeValue="in_progress"
                      greenValue="done"
                      redValue="cancel"
                      text={element?.stage_id}
                    />
                  </Col>
                </Row>
              </div>
            }
          >
            <div className="takaful--table-service-container">
              <Table
                className="takaful--table"
                style={{ direction: "rtl" }}
                columns={columns}
                scroll={{ x: "max-content" }}
                dataSource={element?.line_ids}
                pagination={false}
                locale={{
                  emptyText: (
                    <span className="takaful--empty-text-table">
                      لا توجد بيانات
                    </span>
                  ),
                }}
              />
            </div>
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
  );
};
